module.exports = __webpack_public_path__ + "img/M052.63defc34.png";